import React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { FaEye } from 'react-icons/fa';
import { Html } from 'react-konva-utils';
import { CanvasButton } from '../common/CanvasButton';
import { FaEyeSlash } from 'react-icons/fa';

interface CanvasDetectionControlsProps {
  hideDetectionCanvas: boolean;
  setHideDetectionCanvas: Dispatch<SetStateAction<boolean>>;
}

const CanvasDetectionControls: React.FC<CanvasDetectionControlsProps> = ({
  hideDetectionCanvas,
  setHideDetectionCanvas,
}) => {
  return (
    <Html transformFunc={(attrs) => ({ ...attrs, x: 14, y: 14 })}>
      <div id="canvas-detection-controls">
        <CanvasButton
          icon={
            hideDetectionCanvas ? (
              <FaEyeSlash className="text-md dark:text-neutralText-dark sm:text-lg" />
            ) : (
              <FaEye className="text-md dark:text-neutralText-dark sm:text-lg" />
            )
          }
          tooltipContent={
            hideDetectionCanvas
              ? 'Afficher les détections (espace)'
              : 'Masquer les détections (espace)'
          }
          tooltipPlace="bottom"
          onClick={() => setHideDetectionCanvas((prevState) => !prevState)}
          addStyle={`${
            !hideDetectionCanvas ? '!bg-errorText-dark !text-neutralBG' : ''
          }`}
        />
      </div>
    </Html>
  );
};

export default CanvasDetectionControls;
